import { createSelector } from 'reselect';
import { reducerUserName } from './constants';
import { initialState } from './reducer';
var userManagerStorageSelector = function (store) {
    return store[reducerUserName] || initialState;
};
export var getUserInfo = createSelector(userManagerStorageSelector, function (_a) {
    var userInfo = _a.userInfo;
    return userInfo;
});
export var getUserInfoIsLoading = createSelector(userManagerStorageSelector, function (_a) {
    var loadingUserInfo = _a.loadingUserInfo;
    return loadingUserInfo;
});
export var getUserPermissionsIsLoading = createSelector(userManagerStorageSelector, function (_a) {
    var loadingUserPermissions = _a.loadingUserPermissions;
    return loadingUserPermissions;
});
// странная запись - расскажи мне на ревью зачем это тут и почему нельзя обойтись
// обычными селекторами + утилитами для форматирования
export var userPermissionsScopeSelector = function (store, scope) { return userManagerStorageSelector(store).permissions[scope]; };
export var userDataPermissionsScopeSelector = function (store, scope) { return userManagerStorageSelector(store).permissionsData[scope]; };
export var getUserPermissions = createSelector(userPermissionsScopeSelector, function (permissions) { return permissions; });
export var getUserDataPermissions = createSelector(userDataPermissionsScopeSelector, function (permissionsData) { return permissionsData; });
export var getUserAllPermissions = createSelector(userManagerStorageSelector, function (_a) {
    var permissions = _a.permissions;
    return permissions;
});
